export enum UserRoles {
  Admin = 'frontend-admin',
  Client = 'client',
  IT = 'IT',
  Default = 'default',
}
